import { TRIAL_DAYS } from '@/config';
import { useTranslation } from 'react-i18next';
import { redirectToCheckout, showError } from '@/utils';

import { useDispatch } from 'react-redux';

import paymentModel from '@/models/payment';
import { setPrice } from '@/store/checkout';
import { setCurrency } from '@/store/auth';

export function useGetPaymentReference() {
	const { t } = useTranslation();

	function getPaymentReference(data) {
		if (data.trial) {
			return t('billing.subscription.references.trial', {
				trialDays: TRIAL_DAYS
			});
		}

		if (data.service) {
			return t('billing.subscription.references.service');
		}

		if (data.storage) {
			return t('billing.subscription.references.storage');
		}

		return t('billing.subscription.references.generic');
	}

	return getPaymentReference;
}

export function useHandleRetry() {
	const dispatch = useDispatch();

	return async function ({ priceId: priceIdParam, handlerId, currency }) {
		try {
			let priceId = priceIdParam;

			if (!priceId) {
				const response = await paymentModel.getByHandlerId(handlerId);

				priceId = response?.priceId || null;
			}

			dispatch(
				setPrice({
					id: priceId,
					paymentHandlerId: handlerId
				})
			);

			const payload = {
				priceId,
				paymentHandlerId: handlerId
			};

			if (currency) {
				dispatch(setCurrency(currency));

				payload.currency = currency;
			}

			redirectToCheckout(payload);
		} catch (error) {
			showError(error);
		}
	};
}
